import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
// import { toSelect } from 'utils/genericFunctions';
import { Types, ConsultarParametrosLocalidadeV2 } from './types';

export const INITIAL_STATE: ConsultarParametrosLocalidadeV2 = {
	status: 0,
	data: null,
	enum: [],
	// totalRegistrosConsulta: 0,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultarParametrosLocalidadeV2 {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_PARAMETROS_LOCALIDADE_V2: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.enum = INITIAL_STATE.enum;
				// draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				break;
			}

			case Types.CONSULTAR_PARAMETROS_LOCALIDADE_V2_SUCCESS: {
				// draft.enum = toSelect(action.payload.data, 'descricao', 'codigo');
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				// draft.totalRegistrosConsulta =
				// 	action.payload.headers['x-num-registros'];
				break;
			}

			case Types.CONSULTAR_PARAMETROS_LOCALIDADE_V2_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CONSULTAR_PARAMETROS_LOCALIDADE_V2_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.enum = INITIAL_STATE.enum;
				// draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				break;
			}

			default:
		}
	});
}
